import { ApolloProvider } from '@apollo/react-hoc'
import { CSSReset, ThemeProvider } from '@chakra-ui/core'
import { css, Global } from '@emotion/core'
import moment from 'moment-timezone'
import React from 'react'
import 'react-dates/initialize'
import ReactDOM from 'react-dom'
import { Helmet } from 'react-helmet'
import client from './apollo/client'
import App from './App'
import { API_HOST, APP_NAME } from './constants'
import { AppProvider, AuthProvider, PreviewerProvider } from './context'
import * as serviceWorker from './serviceWorker'
import { theme } from './theme'
import { initAnalytics } from './lib/analytics'

moment.tz.setDefault('Africa/Nairobi')

initAnalytics({ apiHost: API_HOST })

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <AuthProvider>
          <Helmet titleTemplate={`${APP_NAME} | %s`} />
          <AppProvider>
            <PreviewerProvider>
              <CSSReset />
              <Global
                styles={css`
                  @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,500;0,700;1,300&display=swap');
                  @import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');
                  * {
                    font-family: ${theme.fonts.body};
                  }
                  *:focus {
                    box-shadow: none !important;
                  }
                  ::placeholder {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */
                    font-size: small;
                    opacity: 1; /* Firefox */
                  }
                  button {
                    cursor: pointer;
                  }

                  :-ms-input-placeholder {
                    /* Internet Explorer 10-11 */
                    font-size: small;
                  }

                  ::-ms-input-placeholder {
                    /* Microsoft Edge */
                    font-size: small;
                  }
                `}
              />
              <App />
            </PreviewerProvider>
          </AppProvider>
        </AuthProvider>
      </ThemeProvider>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register()
